import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16.5 20h-14c-.827 0-1.5-.673-1.5-1.5v-13C1 4.673 1.673 4 2.5 4h14c.827 0 1.5.673 1.5 1.5v13c0 .827-.673 1.5-1.5 1.5zM2.5 5c-.276 0-.5.224-.5.5v13c0 .276.224.5.5.5h14c.276 0 .5-.224.5-.5v-13c0-.276-.224-.5-.5-.5h-14zM16.5 3h-14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h14c.276 0 .5.224.5.5s-.224.5-.5.5zM15.5 1h-12C3.224 1 3 .776 3 .5s.224-.5.5-.5h12c.276 0 .5.224.5.5s-.224.5-.5.5z',
    'M11.5 13c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z',
    'M14.5 8h-10c-.276 0-.5.224-.5.5v7c0 .276.224.5.5.5h10c.276 0 .5-.224.5-.5v-7c0-.276-.224-.5-.5-.5zM5 13.675l1.266-1.582c.073-.091.164-.142.259-.144s.189.044.266.131L9.387 15H5v-1.325zM14 15h-3.275l-3.187-3.585c-.272-.306-.651-.476-1.039-.466s-.758.199-1.014.519L5 12.074V8.999h9V15z',
  ],
  height: 20,
  width: 20,
});
